import { render, staticRenderFns } from "./TableManager.vue?vue&type=template&id=a0310e9c"
import script from "./TableManager.vue?vue&type=script&lang=js"
export * from "./TableManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports